import React, { Component } from 'react'
import Popover from 'react-popover'
import { withTranslation } from 'react-i18next'

import aboutImageSrc from 'app/assets/images/repeat-activity-about.svg'

import './styles.scss'

const baseClass = 'activity-repeat-about'

class ActivityRepeatAbout extends Component {
  state = {
    isOpen: false,
  }

  render() {
    const { t } = this.props
    return (
      <div className={baseClass}>
        <Popover
          isOpen={this.state.isOpen}
          onOuterAction={() => this.setState({ isOpen: false })}
          body={
            <div className={`${baseClass}__body`}>
              <div className={`${baseClass}__image-wrapper`}>
                <img src={aboutImageSrc} className={`${baseClass}__image`} />
              </div>
              <div className={`${baseClass}__text`}>{t(`Turn this activity into a habit`)}</div>
            </div>
          }
        >
          <div
            className={`${baseClass}__trigger`}
            onMouseOver={() => this.setState({ isOpen: true })}
            onMouseOut={() => this.setState({ isOpen: false })}
          >
            ?
          </div>
        </Popover>
      </div>
    )
  }
}

export default withTranslation('user')(ActivityRepeatAbout)
